import { Component } from "react";
import platform from "Pub/js/platform";
const { NCFormControl } = platform.base;
import "./index.less";

export default class ImitateRefer extends Component {
    render() {
        const { value, className, onClick, placeholder, fieldid = '' } = this.props;
        return <div fieldid={`imitate-refer${fieldid ? '-' + fieldid : ''}`} className={`imitate-refer ${className}`} onClick={onClick}>
            <NCFormControl placeholder={placeholder} value={value} />
            <i className='iconfont icon-icon-canzhao canzhao'></i>
            {/* <i class="iconfont icon-qingkong empty" onClick={() => {}}></i> */}
        </div>
    }
}